module.exports = __webpack_public_path__ + "static/media/wip-small.d2b9431a.png";